export const it = {
  // Common
  common: {
    loading: 'Caricamento...',
    error: 'Errore',
    save: 'Salva',
    cancel: 'Annulla',
    delete: 'Elimina',
    edit: 'Modifica',
    create: 'Crea',
    search: 'Cerca',
    filter: 'Filtra',
    export: 'Esporta',
    refresh: 'Aggiorna',
    back: 'Indietro',
    next: 'Avanti',
    previous: 'Precedente',
    confirm: 'Conferma',
    close: 'Chiudi',
    yes: 'Si',
    no: 'No',
    all: 'Tutti',
    none: 'Nessuno',
    noData: 'Nessun dato disponibile',
    required: 'Richiesto',
    optional: 'Opzionale',
    tryAgain: 'Riprova',
  },

  // Auth
  auth: {
    login: 'Accedi',
    logout: 'Esci',
    signup: 'Registrati',
    forgotPassword: 'Password dimenticata?',
    resetPassword: 'Reimposta password',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Conferma password',
    newPassword: 'Nuova password',
    currentPassword: 'Password attuale',
    rememberMe: 'Ricordami',
    noAccount: 'Non hai un account?',
    hasAccount: 'Hai già un account?',
    signupNow: 'Registrati ora',
    loginNow: 'Accedi ora',
    welcomeBack: 'Bentornato',
    createAccount: 'Crea il tuo account',
    invalidCredentials: 'Credenziali non valide',
    passwordMismatch: 'Le password non coincidono',
    passwordReset: 'Ti abbiamo inviato un link per reimpostare la password',
    companyName: 'Nome azienda',
    firstName: 'Nome',
    lastName: 'Cognome',
    confirmAccount: 'Conferma il tuo account',
    verificationCodeSent: 'Abbiamo inviato un codice di verifica a {{email}}',
    yourEmail: 'la tua email',
    verificationCode: 'Codice di verifica',
    resendCode: 'Invia di nuovo il codice',
    waitSeconds: 'Attendi {{seconds}} secondi...',
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    analytics: 'Analisi',
    sales: 'Vendite',
    products: 'Prodotti',
    customers: 'Clienti',
    geography: 'Geografia',
    compare: 'Confronta',
    settings: 'Impostazioni',
    users: 'Utenti',
    connectors: 'Connettori',
    jobs: 'Attività',
    profile: 'Profilo',
    billing: 'Fatturazione',
    team: 'Team',
    // E-commerce
    brands: 'Brand',
    categories: 'Categorie',
    channels: 'Canali',
    retention: 'Retention',
    rfm: 'Analisi RFM',
    inventory: 'Inventario',
    supplierOrders: 'Ordini Fornitore',
    smartReorder: 'Smart Reorder',
    orders: 'Ordini',
    fulfillment: 'Fulfillment',
    pnl: 'Conto Economico',
    seasonality: 'Stagionalità',
    // SaaS
    mrr: 'MRR',
    churn: 'Churn',
    cac: 'CAC',
    ltv: 'LTV',
    unitEconomics: 'Unit Economics',
    trialConversion: 'Conversione Trial',
    // Restaurant
    service: 'Servizio',
    menu: 'Menu',
    laborCost: 'Costo Lavoro',
    recipeProfitability: 'Redditività Ricette',
    locationPnl: 'P&L Locale',
    // Fashion
    sizePerformance: 'Performance Taglie',
    colorPerformance: 'Performance Colori',
    stores: 'Negozi',
    variants: 'Varianti',
    collections: 'Collezioni',
    returns: 'Resi',
    // Logistics
    deliveries: 'Consegne',
    fleet: 'Flotta',
    driverPerformance: 'Performance Autisti',
    customerSatisfaction: 'Soddisfazione Clienti',
    // Healthcare
    appointments: 'Appuntamenti',
    patients: 'Pazienti',
    treatments: 'Trattamenti',
    // Fitness
    memberships: 'Abbonamenti',
    attendance: 'Presenze',
    classes: 'Corsi',
    // Hotel
    occupancy: 'Occupazione',
    bookings: 'Prenotazioni',
    revpar: 'RevPAR',
    // Manufacturing
    production: 'Produzione',
    oee: 'OEE',
    defects: 'Difetti',
    // Sales Agent
    customersMap: 'Mappa Clienti',
    territory: 'Territorio',
    productMix: 'Mix Prodotti',
    upload: 'Carica Dati',
    // Groups
    groups: {
      overview: 'Panoramica',
      sales: 'Vendite',
      catalog: 'Catalogo',
      customers: 'Clienti',
      operations: 'Operazioni',
    },
    favorites: 'Preferiti',
    pinToFavorites: 'Aggiungi ai preferiti',
    unpinFromFavorites: 'Rimuovi dai preferiti',
    maxFavoritesReached: 'Massimo {{max}} preferiti',
  },

  // Analytics
  analytics: {
    trend: 'Andamento',
    salesTrend: 'Andamento Vendite',
    by: 'Per {{dimension}}',
    // KPI titles
    totalCustomers: 'Clienti Totali',
    totalRevenue: 'Fatturato Totale',
    avgRevenuePerCustomer: 'Fatturato Medio/Cliente',
    newCustomers: 'Nuovi Clienti',
    activeBrands: 'Brand Attivi',
    activeCategories: 'Categorie Attive',
    activeSkus: 'SKU Attivi',
    activeProducts: 'Prodotti Attivi',
    activationPercent: 'Attivazione %',
    marginPercent: '% Margine',
    grossMargin: 'Margine Lordo',
    topConcentration: 'Conc. Top 10%',
    top3Concentration: 'Conc. Top 3',
    negativeMargin: 'Sottocosto',
    catalogCoverage: 'Copertura Catalogo',
    // Chart titles
    revenueBySegment: 'Fatturato per Segmento',
    customersBySegment: 'Clienti per Segmento',
    revenueConcentration: 'Concentrazione Revenue',
    abcAnalysis: 'Analisi ABC (Pareto)',
    brandTrend: 'Trend Brand',
    categoryTrend: 'Trend Categorie',
    productTrend: 'Andamento',
    // Dynamic titles with interpolation
    topBrands: 'Top {{count}} Brand',
    topCategories: 'Top {{count}} Categorie',
    topProducts: 'Top {{count}} Prodotti',
    topCustomers: 'Top {{count}} Clienti',
    // Customer charts
    revenueByCustomer: 'Fatturato per Cliente',
    quantityByCustomer: 'Quantità per Cliente',
    // Retention metrics
    repeatRate: 'Tasso Riacquisto',
    avgClv: 'CLV Medio',
    newVsReturning: 'Nuovi vs Ricorrenti',
    returningCustomers: 'Ricorrenti',
    orderFrequency: 'Frequenza Ordini',
    // Alerts
    belowCostWarning: 'Attenzione: Vendite Sottocosto',
    belowCostMessage: '{{count}} prodotti venduti sottocosto. Rivedi i prezzi per proteggere i margini.',
    // Resource detail
    dailyTrend: 'Trend Giornaliero',
    currentPeriod: 'Corrente',
    previousPeriod: 'Precedente',
    change: 'Variazione',
    avgPrice: 'Prezzo Medio',
    productCount: 'Prodotti',
    customerCount: 'Clienti',
    brandCount: 'Brand',
    noResourceData: 'Nessun dato trovato per questa risorsa',
    searchBrand: 'Cerca brand...',
    searchCategory: 'Cerca categoria...',
    searchProduct: 'Cerca prodotto...',
    searchGeography: 'Cerca regione...',
    searchSupplier: 'Cerca fornitore...',
    searchCustomer: 'Cerca cliente...',
    sinceLastOrder: "dall'ultimo ordine",
    vatNumber: 'P.IVA',
    negativeMarginAlert: 'Attenzione: margine negativo ({{percent}}). Rivedi la strategia di pricing.',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    overview: 'Panoramica',
    totalRevenue: 'Fatturato Totale',
    totalOrders: 'Ordini Totali',
    grossProfit: 'Margine Lordo',
    averageOrderValue: 'Valore Medio Ordine',
    newCustomers: 'Nuovi Clienti',
    returningCustomers: 'Clienti Abituali',
    itemsSold: 'Articoli Venduti',
    uniqueCustomers: 'Clienti Unici',
    vsLastPeriod: 'vs periodo precedente',
    revenueByChannel: 'Fatturato per Canale',
    ordersByChannel: 'Ordini per Canale',
    topProducts: 'Prodotti più Venduti',
    revenueTrend: 'Andamento Fatturato',
    ordersPerDay: 'Ordini al Giorno',
    noData: 'Nessun dato disponibile',
    units: 'unità',
    revenue: 'Fatturato',
    orders: 'Ordini',
    profitMargin: 'Margine di Profitto',
    conversionRate: 'Tasso di Conversione',
  },

  // Filters
  filters: {
    dateRange: 'Periodo',
    today: 'Oggi',
    last7Days: 'Ultimi 7 giorni',
    last30Days: 'Ultimi 30 giorni',
    last90Days: 'Ultimi 90 giorni',
    monthToDate: "Dall'inizio del mese",
    yearToDate: "Dall'inizio dell'anno",
    custom: 'Personalizzato',
    from: 'Da',
    to: 'A',
    channels: 'Canali',
    compare: 'Confronta',
    compareTo: 'Confronta con',
  },

  // Settings
  settings: {
    title: 'Impostazioni',
    general: 'Generali',
    profile: 'Profilo',
    billing: 'Fatturazione',
    team: 'Team',
    connectors: 'Connettori',
    timezone: 'Fuso orario',
    currency: 'Valuta',
    language: 'Lingua',
    notifications: 'Notifiche',
    currentPlan: 'Piano attuale',
    usage: 'Utilizzo',
    upgrade: 'Aggiorna piano',
    inviteUser: 'Invita utente',
    role: 'Ruolo',
    roles: {
      owner: 'Proprietario',
      analyst: 'Analista',
      viewer: 'Visualizzatore',
    },
  },

  // Users
  users: {
    title: 'Utenti',
    invite: 'Invita utente',
    name: 'Nome',
    email: 'Email',
    role: 'Ruolo',
    status: 'Stato',
    lastActive: 'Ultimo accesso',
    actions: 'Azioni',
    deleteConfirm: 'Sei sicuro di voler eliminare questo utente?',
    inviteSent: 'Invito inviato con successo',
    statuses: {
      active: 'Attivo',
      pending: 'In attesa',
      disabled: 'Disabilitato',
    },
  },

  // Connectors
  connectors: {
    title: 'Connettori',
    add: 'Aggiungi connettore',
    platform: 'Piattaforma',
    status: 'Stato',
    lastSync: 'Ultima sincronizzazione',
    testConnection: 'Testa connessione',
    connectionSuccess: 'Connessione riuscita',
    connectionFailed: 'Connessione fallita',
    apiKey: 'Chiave API',
    apiSecret: 'Segreto API',
    shopUrl: 'URL negozio',
    statuses: {
      active: 'Attivo',
      error: 'Errore',
      syncing: 'Sincronizzazione',
      disabled: 'Disabilitato',
    },
  },

  // Errors
  errors: {
    generic: 'Si è verificato un errore. Riprova più tardi.',
    network: 'Errore di connessione. Verifica la tua connessione internet.',
    unauthorized: 'Sessione scaduta. Effettua nuovamente il login.',
    forbidden: 'Non hai i permessi per eseguire questa azione.',
    notFound: 'Risorsa non trovata.',
    validation: 'Verifica i dati inseriti.',
    serverError: 'Errore del server. Riprova più tardi.',
  },

  // Onboarding
  onboarding: {
    welcome: 'Benvenuto in Leviathan BI',
    step1Title: 'Scegli la piattaforma',
    step1Subtitle: 'Seleziona la piattaforma che vuoi connettere',
    step2Title: 'Connetti il tuo negozio',
    step2Subtitle: 'Inserisci le credenziali API',
    step3Title: 'Scegli il piano',
    step3Subtitle: 'Seleziona il piano più adatto alle tue esigenze',
    orderVolume: 'Volume ordini mensili',
    platforms: {
      shopify: 'Shopify',
      woocommerce: 'WooCommerce',
      magento: 'Magento',
      prestashop: 'PrestaShop',
      amazon: 'Amazon Seller',
      ebay: 'eBay',
    },
  },

  // Pricing
  pricing: {
    title: 'Piani e Prezzi',
    subtitle: 'Scegli il piano perfetto per il tuo business',
    monthly: 'Mensile',
    yearly: 'Annuale',
    savePercent: 'Risparmia {{percent}}%',
    perMonth: '/mese',
    getStarted: 'Inizia ora',
    contactUs: 'Contattaci',
    starter: {
      name: 'Starter',
      description: 'Per piccoli e-commerce',
    },
    professional: {
      name: 'Professional',
      description: 'Per business in crescita',
    },
    business: {
      name: 'Business',
      description: 'Per aziende consolidate',
    },
    enterprise: {
      name: 'Enterprise',
      description: 'Soluzioni personalizzate',
    },
  },

  // Tables - common headers
  tables: {
    rank: '#',
    name: 'Nome',
    customer: 'Cliente',
    brand: 'Brand',
    category: 'Categoria',
    product: 'Prodotto',
    sku: 'SKU',
    revenue: 'Fatturato',
    margin: 'Margine',
    marginPercent: '% Marg',
    orders: 'Ordini',
    quantity: 'Quantità',
    products: 'Prodotti',
    share: 'Quota',
    lastOrder: 'Ultimo Ordine',
    class: 'Classe',
    locality: 'Località',
    yoyChange: 'Var. YoY',
  },

  // Catalog (generic paginated table)
  catalog: {
    search: 'Cerca...',
    perPage: 'per pagina',
    showing: '{{from}}-{{to}} di {{total}}',
    viewAll: 'Vedi tutti',
    viewAllCount: 'Vedi tutti ({{count}})',
    noResults: 'Nessun risultato trovato.',
    noData: 'Nessun dato disponibile.',
    prev: 'Prec',
    next: 'Succ',
    title_product: 'Prodotti',
    title_brand: 'Brand',
    title_category: 'Categorie',
    title_customer: 'Clienti',
    title_inventory: 'Inventario',
    title_geography: 'Geografia',
  },

  // Geography
  geography: {
    level: 'Livello',
    country: 'Paese',
    region: 'Regione',
    city: 'Città',
    revenueBy: 'Fatturato per {{level}}',
    topByRevenue: 'Top 10 {{level}} per Fatturato',
    topLocations: 'Top 10 {{level}}',
    activeAreas: 'Aree Attive',
  },

  // Map (Sales Agent)
  map: {
    subtitle: '{{count}} clienti con coordinate',
    year: 'Anno',
    compareYear: 'Anno confronto',
    brand: 'Brand',
    allBrands: 'Tutti i brand',
    colorBy: 'Colora per',
    colorByQuantity: 'Quantità',
    colorByRevenue: 'Fatturato',
    colorByYoY: 'YoY %',
    totalCustomers: 'Clienti Totali',
    totalQuantity: 'Quantità Totale',
    totalRevenue: 'Fatturato Totale',
    avgYoY: 'Var. Media YoY',
    customerLocations: 'Posizioni Clienti',
    noCustomersWithCoords: 'Nessun cliente con coordinate disponibili',
    topCustomers: 'Top Clienti',
    locality: 'Località',
    province: 'Provincia',
    address: 'Indirizzo',
    quantity: 'Quantità',
    revenue: 'Fatturato',
    yoyChange: 'Var. YoY',
    segment: 'Segmento',
  },

  // Empty states
  empty: {
    noData: 'Nessun dato disponibile',
    noDataDescription: 'Configura una connessione dati per iniziare.',
    noProducts: 'Nessun prodotto trovato',
    noProductsDescription: 'I prodotti appariranno qui dopo la sincronizzazione.',
    noTeamMembers: 'Nessun membro del team',
    noTeamMembersDescription: 'Invita collaboratori per lavorare insieme.',
    noConnectors: 'Nessun connettore configurato',
    noConnectorsDescription: 'Aggiungi il tuo primo connettore per importare i dati.',
    noResults: 'Nessun risultato',
    noSearchResults: 'Nessun risultato per "{{query}}"',
  },

  // Actions
  actions: {
    configureData: 'Configura Dati',
    inviteUser: 'Invita Utente',
    addConnector: 'Aggiungi Connettore',
  },

  // Validation messages
  validation: {
    invalidEmail: 'Email non valida',
    passwordRequired: 'Password richiesta',
    companyNameRequired: 'Nome azienda richiesto',
    firstNameRequired: 'Nome richiesto',
    lastNameRequired: 'Cognome richiesto',
    minChars: 'Minimo {{count}} caratteri',
    passwordMismatch: 'Le password non coincidono',
    codeRequired: 'Codice di 6 cifre richiesto',
    accountConfirmed: 'Account confermato! Effettua il login.',
  },

  // UI elements
  ui: {
    switchToEnglish: 'Switch to English',
    switchToItalian: 'Passa a Italiano',
    darkMode: 'Tema scuro',
    lightMode: 'Tema chiaro',
    macro: 'Macro',
    micro: 'Micro',
  },

  // Inventory
  inventory: {
    totalProducts: 'Prodotti Totali',
    totalStock: 'Giacenza Totale',
    reservedStock: 'Riservato',
    stockValue: 'Valore Giacenza',
    lowStock: 'Sotto Scorta',
    outOfStock: 'Esaurito',
    stockTrend: 'Andamento Giacenza',
    byWarehouse: 'Per Magazzino',
    topByStockValue: 'Top Prodotti per Valore Giacenza',
    stockLevel: 'Giacenza',
    reserved: 'Riservato',
    daysOfSupply: 'Giorni Copertura',
    turnoverRate: 'Indice Rotazione',
    reorderPoint: 'Punto Riordino',
    warehouse: 'Magazzino',
    allWarehouses: 'Tutti i magazzini',
    stockAlert: 'Attenzione: Criticità Scorte',
    stockAlertMessage: '{{low}} prodotti sotto scorta e {{oos}} esauriti. Verifica gli approvvigionamenti.',
  },

  // Supplier Orders
  supplierOrders: {
    totalSpend: 'Spesa Totale',
    totalOrders: 'Ordini',
    fillRate: 'Fill Rate',
    avgLeadTime: 'Lead Time Medio',
    activeSuppliers: 'Fornitori Attivi',
    nonConformities: 'Non Conformità',
    spendTrend: 'Andamento Spesa & Ordini',
    spend: 'Spesa',
    orders: 'Ordini',
    orderPipeline: 'Pipeline Ordini',
    fulfillmentBreakdown: 'Evasione Righe',
    topSuppliers: 'Top Fornitori per Spesa',
    supplierTable: 'Dettaglio Fornitori',
    supplier: 'Fornitore',
    city: 'Città',
    leadTime: 'Lead Time',
    nonConf: 'Non Conf.',
    scorecard: 'Scorecard Fornitori',
    onTimeRate: 'On-Time %',
    nonConfRate: 'Non Conf. %',
    fulfillmentRate: 'Evasione %',
    score: 'Score',
    grade: 'Voto',
  },

  // Smart Reorder
  smartReorder: {
    title: 'Smart Reorder',
    subtitle: 'Raccomandazioni d\'acquisto intelligenti basate su vendite, inventario e performance fornitori',
    preset: 'Strategia',
    conservative: 'Conservativo',
    balanced: 'Bilanciato',
    aggressive: 'Aggressivo',
    custom: 'Personalizzato',
    lookbackDays: 'Giorni di Lookback',
    coverageTarget: 'Copertura Target (gg)',
    safetyMargin: 'Margine di Sicurezza (%)',
    productsToReorder: 'Da Riordinare',
    criticalCount: 'Critici',
    estimatedValue: 'Valore Stimato',
    avgDaysStockout: 'Gg Medi a Rottura',
    suppliersInvolved: 'Fornitori Coinvolti',
    totalProducts: 'Prodotti Analizzati',
    priorityBreakdown: 'Ripartizione per Priorità',
    supplierBreakdown: 'Costo Stimato per Fornitore',
    recommendations: 'Raccomandazioni',
    product: 'Prodotto',
    sku: 'SKU',
    brand: 'Brand',
    stock: 'Stock',
    demand: 'Domanda/gg',
    daysLeft: 'Gg Rimasti',
    suggestedQty: 'Qtà Suggerita',
    estCost: 'Costo Stimato',
    supplier: 'Fornitore',
    leadTime: 'Lead Time',
    priority: 'Priorità',
    grade: 'Voto',
    allSuppliers: 'Tutti i fornitori',
    exportCsv: 'Esporta CSV',
    noData: 'Dati inventario non disponibili',
    filterByPriority: 'Filtra per priorità',
    searchProducts: 'Cerca prodotto, SKU, brand, fornitore...',
    viewByProduct: 'Per Prodotto',
    viewBySupplier: 'Per Fornitore',
    trend: 'Trend',
    adjustedForFillRate: 'Quantità corretta per fill rate',
    products: 'prodotti',
    subtotal: 'Subtotale',
    incoming: 'In Arrivo',
    allBrands: 'Tutti i brand',
    outOfStock: 'Esaurito',
    lowStock: 'In Esaurimento',
    inStock: 'Disponibile',
    allIncoming: 'Tutti',
    withIncoming: 'Con arrivo',
    withoutIncoming: 'Senza arrivo',
    allSupplierPresence: 'Tutti',
    withSupplier: 'Con fornitore',
    withoutSupplier: 'Senza fornitore',
    resetFilters: 'Reset filtri',
  },

  // Orders
  orders: {
    totalOrders: 'Ordini Totali',
    revenue: 'Fatturato',
    aov: 'Scontrino Medio',
    couponRate: '% Coupon',
    firstOrderRate: '% Primo Ordine',
    uniqueCustomers: 'Clienti Unici',
    avgItemsPerOrder: 'Articoli/Ordine',
    avgDiscount: 'Sconto Medio',
    ordersTrend: 'Andamento Ordini & Fatturato',
    orders: 'Ordini',
    byPaymentMethod: 'Metodo di Pagamento',
    byCarrier: 'Corriere',
    byGeography: 'Fatturato per Regione',
    orderPipeline: 'Pipeline Ordini',
    hourlyDistribution: 'Distribuzione Oraria',
    couponAnalysis: 'Analisi Coupon',
    withCoupon: 'Con Coupon',
    withoutCoupon: 'Senza Coupon',
    firstVsRepeat: 'Primo vs Ripetuto',
    firstOrder: 'Primo Ordine',
    repeatOrder: 'Ordine Ripetuto',
    topCoupons: 'Top Coupon',
    couponCode: 'Codice Coupon',
    usageCount: 'Utilizzi',
    avgOrderValue: 'Scontrino Medio',
    hour: 'Ora',
  },

  // Fulfillment
  fulfillment: {
    avgPickingTime: 'Tempo Picking Medio',
    avgShippingTime: 'Tempo Spedizione Medio',
    completedRate: '% Completati',
    avgTransitions: 'Transizioni Medie',
    avgTimeToComplete: 'Tempo Medio Completamento',
    stateFunnel: 'Funnel Stati',
    avgTimePerState: 'Tempo Medio per Stato',
    fulfillmentTrend: 'Andamento Fulfillment',
    carrierPerformance: 'Performance Corrieri',
    slaDistribution: 'Distribuzione Tempi',
    carrier: 'Corriere',
    orders: 'Ordini',
    avgTime: 'Tempo Medio',
    pickingTime: 'Tempo Picking',
    shippingTime: 'Tempo Spedizione',
    byGeography: 'Fulfillment per Regione',
  },

  // P&L
  pnl: {
    grossRevenue: 'Fatturato Lordo',
    discounts: 'Sconti',
    discountRate: '% Sconto',
    netRevenue: 'Fatturato Netto',
    costOfGoods: 'Costo del Venduto',
    grossMargin: 'Margine Lordo',
    marginPercent: 'Margine %',
    avgOrderValue: 'Scontrino Medio',
    revenueTrend: 'Andamento Ricavi',
    marginTrend: 'Andamento Margine & Sconti',
    channelBreakdown: 'Breakdown per Canale',
    geographyBreakdown: 'P&L per Regione',
    categoryBreakdown: 'Top Categorie per Margine',
    channel: 'Canale',
  },

  // Seasonality
  seasonality: {
    bestMonth: 'Mese Migliore',
    worstMonth: 'Mese Peggiore',
    bestDay: 'Giorno Migliore',
    seasonalityIndex: 'Indice Stagionalità',
    monthlyHeatmap: 'Heatmap Mensile',
    dayOfWeek: 'Revenue Media per Giorno',
    yoyComparison: 'Confronto Anno su Anno',
  },

  // Upload
  upload: {
    pageTitle: 'Carica Dati',
    pageDescription: 'Importa i tuoi dati da file CSV o Excel',
    uploading: 'Caricamento in corso...',
    confirm: 'Conferma e Importa',
    step: {
      select: {
        title: 'Seleziona File',
        description: 'Trascina un file CSV o Excel o clicca per selezionarlo',
      },
    },
    dropzone: {
      title: 'Trascina il file qui o clicca per selezionarlo',
      subtitle: 'Formati supportati: {{formats}}',
    },
    preview: {
      title: 'Anteprima Dati',
      rowCount: '{{count}} righe totali',
    },
    mapping: {
      title: 'Mappatura Colonne',
      description: 'Associa le colonne del file ai campi del sistema',
      selectColumn: '-- Seleziona colonna --',
      optional: 'opzionale',
      missingRequired: 'Campi richiesti mancanti: {{fields}}',
    },
    entity: {
      customer: 'Clienti',
      brand: 'Brand',
      product: 'Prodotti',
      sales: 'Vendite',
    },
    smartImport: {
      detected: {
        title: 'Smart Import Rilevato',
        description: 'Abbiamo rilevato un formato pivot con anni come colonne. Possiamo importare automaticamente i dati.',
      },
      yearColumns: 'Colonne Anno',
      yearsDetected: 'anni rilevati',
      transformation: 'Trasformazione',
      rowsIn: 'righe in ingresso',
      factRowsOut: 'righe di vendita',
      entitiesFound: 'Entità Trovate',
      entitiesDescription: 'Queste entità verranno create o aggiornate automaticamente',
      useManualMapping: 'Mapping Manuale',
      useSmartImport: 'Usa Smart Import',
    },
    processing: {
      title: 'Elaborazione in corso',
      description: 'Stiamo importando i tuoi dati...',
    },
    complete: {
      title: 'Importazione Completata',
      description: 'I tuoi dati sono stati importati con successo',
      uploadAnother: 'Carica un altro file',
      viewMap: 'Visualizza Mappa',
    },
    error: {
      title: 'Errore di Importazione',
      generic: "Si è verificato un errore durante l'importazione",
      invalidFormat: 'Formato non valido. Formati supportati: {{formats}}',
      fileTooLarge: 'File troppo grande. Dimensione massima: {{maxSize}}',
      timeout: "L'elaborazione sta impiegando troppo tempo. Riprova con un file più piccolo o contatta il supporto.",
    },
  },
}
